import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { useMemo, useState, useEffect, useRef } from 'react';
import { FillInBlankAnswerReport } from './fill-in-blank-answer-report.component';
import styled from '@xstyled/styled-components';
import { getSize, getColor } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var InlineHTMLSpan = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline;\n\n  p {\n    display: inline;\n    margin: 0;\n  }\n\n  img {\n    max-width: 100%;\n    vertical-align: middle;\n  }\n"])));
var DESCRIPTION_COLLAPSED_MAX_HEIGHT = 96;
var StyledDescriptionContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  max-height: ", ";\n  transition: max-height 0.3s ease;\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 56px;\n    background: linear-gradient(to bottom, transparent, #ffffff);\n    pointer-events: none;\n    opacity: ", ";\n    transition: opacity 0.3s ease;\n  }\n"])), function (_ref) {
  var $expanded = _ref.$expanded;
  return $expanded ? 'none' : "".concat(DESCRIPTION_COLLAPSED_MAX_HEIGHT, "px");
}, function (_ref2) {
  var $expanded = _ref2.$expanded,
      $hasOverflow = _ref2.$hasOverflow;
  return !$expanded && $hasOverflow ? 1 : 0;
});
var StyledReadMoreButton = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  gap: 2px;\n  padding: ", " 0 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  line-height: 1.5;\n\n  &:hover span {\n    text-decoration: underline;\n  }\n"])), getSize('padding4'), getSize('typo14'), getColor('fillIntActive'));
var StyledChevron = styled.svg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n  transition: transform 0.3s ease;\n  transform: ", ";\n"])), function (_ref3) {
  var $expanded = _ref3.$expanded;
  return $expanded ? 'rotate(180deg)' : 'rotate(0deg)';
});
var StyledFillInBlankDescription = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: #1e293b;\n  line-height: ", ";\n  font-weight: 400;\n  letter-spacing: 0;\n  cursor: pointer;\n\n  p {\n    margin: 0;\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), getSize('typo14'), getSize('padding20'));
/**
 * Parse HTML string and replace <fib-blank> tags with React components
 * Returns an array of React elements and strings that can be rendered
 * Index is auto-incremented based on order of appearance (1, 2, 3...)
 */

var parseHTMLWithBlanks = function parseHTMLWithBlanks(html, answers, startQuestionIndex) {
  var regex = /<fib-blank\s+[^>]*id="([^"]+)"[^>]*>/g;
  var parts = [];
  var lastIndex = 0;
  var match;
  var keyCounter = 0;
  var blankCounter = startQuestionIndex; // Auto-increment counter for blank indices

  var _loop = function _loop() {
    var _match = match,
        _match2 = _slicedToArray(_match, 2),
        fullMatch = _match2[0],
        uuid = _match2[1]; // Fix: regex only has 1 capture group, so uuid is match[1]


    var matchIndex = match.index; // Add HTML content before the match

    if (matchIndex > lastIndex) {
      var htmlBefore = html.substring(lastIndex, matchIndex);

      if (htmlBefore.trim()) {
        parts.push( /*#__PURE__*/_jsx(InlineHTMLSpan, {
          dangerouslySetInnerHTML: {
            __html: htmlBefore
          }
        }, "html-".concat(keyCounter++)));
      }
    } // Get answer description for this blank (split by "|" to get tags)


    var answerTags = [];
    var answer = answers === null || answers === void 0 ? void 0 : answers.find(function (ans) {
      return ans.id.toString() === uuid;
    });

    if (answer !== null && answer !== void 0 && answer.description) {
      answerTags.push.apply(answerTags, _toConsumableArray(answer.description.split('|').map(function (tag) {
        return tag.trim();
      }).filter(function (tag) {
        return tag.length > 0;
      })));
    }

    parts.push( /*#__PURE__*/_jsx(FillInBlankAnswerReport, {
      index: blankCounter++,
      answerId: uuid,
      answer: answer
    }, uuid));
    lastIndex = matchIndex + fullMatch.length;
  };

  while ((match = regex.exec(html)) !== null) {
    _loop();
  } // Add remaining HTML content after the last match


  if (lastIndex < html.length) {
    var htmlAfter = html.substring(lastIndex);

    if (htmlAfter.trim()) {
      parts.push( /*#__PURE__*/_jsx(InlineHTMLSpan, {
        dangerouslySetInnerHTML: {
          __html: htmlAfter
        }
      }, "html-".concat(keyCounter++)));
    }
  } // If no matches found, render the entire HTML as-is


  if (parts.length === 0 && html.trim()) {
    parts.push( /*#__PURE__*/_jsx(InlineHTMLSpan, {
      dangerouslySetInnerHTML: {
        __html: html
      }
    }, "html-full"));
  }

  return parts;
};

export var FillInBlankDescription = function FillInBlankDescription(_ref4) {
  var description = _ref4.description,
      _ref4$answers = _ref4.answers,
      answers = _ref4$answers === void 0 ? [] : _ref4$answers,
      onAnswer = _ref4.onAnswer,
      startQuestionIndex = _ref4.startQuestionIndex;

  var _useState = useState(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var _useState2 = useState(false),
      hasOverflow = _useState2[0],
      setHasOverflow = _useState2[1];

  var containerRef = useRef(null);
  useEffect(function () {
    setIsExpanded(false);
  }, [description]);
  useEffect(function () {
    var el = containerRef.current;
    if (!el || isExpanded) return;

    var checkOverflow = function checkOverflow() {
      setHasOverflow(el.scrollHeight > el.clientHeight);
    };

    var observer = new ResizeObserver(checkOverflow);
    observer.observe(el);
    checkOverflow();
    return function () {
      return observer.disconnect();
    };
  }, [description, isExpanded]);
  var renderedParts = useMemo(function () {
    return parseHTMLWithBlanks(description, answers, startQuestionIndex);
  }, [description, answers, onAnswer]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledDescriptionContainer, {
      ref: containerRef,
      $expanded: isExpanded,
      $hasOverflow: hasOverflow,
      children: /*#__PURE__*/_jsx(StyledFillInBlankDescription, {
        children: renderedParts
      })
    }), (hasOverflow || isExpanded) && /*#__PURE__*/_jsxs(StyledReadMoreButton, {
      onClick: function onClick(e) {
        e.stopPropagation();
        setIsExpanded(function (prev) {
          return !prev;
        });
      },
      children: [/*#__PURE__*/_jsx("span", {
        children: isExpanded ? 'Read less' : 'Read more'
      }), /*#__PURE__*/_jsx(StyledChevron, {
        $expanded: isExpanded,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsx("path", {
          d: "M4 6L8 10L12 6",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      })]
    })]
  });
};